import { render } from "./Meigaranewsview.vue?vue&type=template&id=434e1fb7&scoped=true"
import script from "./Meigaranewsview.vue?vue&type=script&lang=js"
export * from "./Meigaranewsview.vue?vue&type=script&lang=js"

import "./Meigaranewsview.vue?vue&type=style&index=0&id=434e1fb7&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-434e1fb7"]])

export default __exports__